"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = expandOverflow;

var _StyleCollectorNode = _interopRequireDefault(require("../StyleCollectorNode"));

/**
 * 
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/overflow
 */
function expandOverflow(propertyName, propertyValue) {
  var hashSeed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  if (typeof propertyValue !== 'string') {
    // could not be expanded
    return [new _StyleCollectorNode.default(propertyName, propertyValue, hashSeed)];
  } // The `overflow` property is specified as one or two keywords. If two keywords are specified,
  // the first applies to `overflow-x` and the second to `overflow-y`. Otherwise, both `overflow-x`
  // and `overflow-y` are set to the same value.


  var chunks = propertyValue.split(/\s/);

  if (chunks.length === 2) {
    return [new _StyleCollectorNode.default('overflowX', chunks[0], hashSeed), new _StyleCollectorNode.default('overflowY', chunks[1], hashSeed)];
  }

  return [new _StyleCollectorNode.default('overflowX', propertyValue, hashSeed), new _StyleCollectorNode.default('overflowY', propertyValue, hashSeed)];
}